export default __webpack_public_path__ + "static/media/landscape.bf2918cf.png";